import { MutableRefObject, useEffect } from 'react';
import { FetchNextPageOptions, InfiniteQueryObserverResult } from 'react-query';

type IFetchNextPage = (
  options?: FetchNextPageOptions | undefined
) => Promise<InfiniteQueryObserverResult<any, unknown>>;

export const useLoadNextPage = (
  loadMoreRef: MutableRefObject<any>,
  hasNextPage: boolean | undefined,
  fetchNextPage: IFetchNextPage | undefined,
  isFetching: boolean,
  // Start loading before the sentinel is actually on screen. Short dropdown
  // lists are fine without it; a full page table needs the head start or the
  // user hits the end of the rows before the next page lands.
  rootMargin?: string
) => {
  const loadMoreEntities = () => {
    if (hasNextPage && fetchNextPage) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMoreEntities();
        }
      },
      { threshold: 0.5, rootMargin }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [loadMoreRef, hasNextPage, isFetching, rootMargin]);
};
